"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const errors_1 = require("../errors");
class GTMService {
    constructor(options) {
        var _a;
        this.defaultOptions = options ? options : {};
        this.gtmConfig = ((_a = options === null || options === void 0 ? void 0 : options.config) === null || _a === void 0 ? void 0 : _a.gtmService)
            ? options.config.gtmService
            : null;
    }
    clearECommerceObject() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                try {
                    (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ ecommerce: null });
                }
                catch (e) {
                    reject(e);
                }
                resolve();
            });
        });
    }
    initialize(analyticsOptions) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const config = ((_a = analyticsOptions === null || analyticsOptions === void 0 ? void 0 : analyticsOptions.config) === null || _a === void 0 ? void 0 : _a.gtmService)
                ? analyticsOptions.config.gtmService
                : this.gtmConfig;
            if (config == null) {
                throw new errors_1.ThemisAnalyticsError('Unable to get configuration for GTM');
            }
            try {
                react_gtm_module_1.default.initialize(config);
            }
            catch (error) {
                throw new errors_1.ThemisAnalyticsError('Unable to initialize for GTM' + error);
            }
            return true;
        });
    }
    triggerEvent(event) {
        this.__push({ event });
    }
    triggerCustomEvent(eventName, variables) {
        const baseEventData = { event: eventName };
        const pushEvent = variables
            ? Object.assign(baseEventData, variables)
            : baseEventData;
        this.__push(pushEvent);
    }
    triggerECommerceEvent(event, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.clearECommerceObject().catch((e) => {
                console.warn('Error clearing ecommerce object', e);
            });
            return this.triggerGenericEvent(event, timeout);
        });
    }
    triggerGenericEvent(eventData, eventTimeout) {
        return new Promise((resolve) => {
            try {
                const data = Object.assign(Object.assign({}, eventData), { eventCallback: resolve, eventTimeout: eventTimeout || 4000 });
                this.__push(data);
            }
            catch (error) {
                resolve(`warning: error when pushing to dataLayer: ${error}`);
            }
        });
    }
    __push(pushEvent) {
        window.dataLayer.push(pushEvent);
    }
}
exports.default = GTMService;
//# sourceMappingURL=gtm.service.js.map